/**
 * Custom exceptions for the application
 *
 * This module contains all custom error classes used throughout the application.
 */

/**
 * Error thrown when user account fetching or validation fails during initialization.
 */
export class AccountFetchingError extends Error {
	readonly code = 'ACCOUNT_FETCHING'

	constructor(message: string = 'Failed to fetch or validate user accounts') {
		super(message)
	}
}

/**
 * Error thrown when user is not logged in yet
 */
export class NotLoggedInError extends Error {
	readonly code = 'NOT_LOGGED_IN'

	constructor(message: string = 'User not logged in') {
		super(message)
	}
}

/**
 * Error thrown during user context initialization with specific operation context.
 * This error carries contextual information about where in the initialization flow the error occurred.
 */
export class UserContextError extends Error {
	constructor(message: string, public operation: string, public context: Record<string, any> = {}) {
		super(message)
		this.name = 'UserContextError'
	}
}
